import React from 'react';
import MemberItem from './MemberItem';
import { MembersList as StyledMembersList } from '../../styles/ManageWorkspaceMembers.styles';

const MembersList = ({ members, currentUserId, onRoleChange, onRemoveMember }) => (
    <StyledMembersList>
        {Object.entries(members).map(([uid, member]) => (
            <MemberItem
                key={uid}
                uid={uid}
                member={member}
                isCurrentUser={uid === currentUserId}
                onRoleChange={onRoleChange}
                onRemove={onRemoveMember}
            />
        ))}
    </StyledMembersList>
);

export default MembersList;